import { BillingAddon, BillingPlan, BillingSubscription, BillingTier } from "types/generated";

export type GetBillingGql = {
  billedExternally: boolean;
  billingSubscription?: BillingSubscription;
  onTrialUntil?: number;
  tier: BillingTier;
  availableBillingAddons: BillingAddon[];
  availableSelfServicePlans: BillingPlan[];
};

export type BillingAddressFields = {
  country: string;
  state: string;
  city: string;
  address: string;
  zipCode: string;
  companyName: string;
};

export type InvoicingDetailsFields = {
  fullName: string;
  email: string;
} & BillingAddressFields;

export enum StripeSubscriptionStatus {
  Active = "active",
  Incomplete = "incomplete",
  IncompleteExpired = "incomplete_expired",
  PastDue = "past_due",
  Unpaid = "unpaid",
}
